import { useSelector } from 'react-redux';
import { Module, ModuleName } from '../types/modules';
import {
  getModule,
  getModuleName,
  getModuleVersion,
} from '../redux/selectors/modules';
import { AppState } from '../types/store';
import useGruser from './useGruser';
import camelCase from 'lodash/camelCase';

export const useModule = (moduleId: number): Module | undefined => {
  const { gruser } = useGruser();
  return useSelector<AppState, any>(state =>
    getModule(state, gruser, moduleId)
  );
};

export const useModuleName = (moduleId: number): ModuleName | undefined => {
  const { gruser } = useGruser();
  return camelCase(
    useSelector<AppState, any>(state =>
      getModuleName(state, gruser, moduleId)
    ) || ''
  ) as ModuleName;
};

export const useModuleVersion = (moduleId: number): number | undefined => {
  const { gruser } = useGruser();
  return useSelector<AppState, any>(state =>
    getModuleVersion(state, gruser, moduleId)
  );
};

export default useModule;
